/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import MomentUtils from '@date-io/moment'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import moment from 'moment'

const useStyles = makeStyles(() =>
  createStyles({
    input: {
      maxWidth: '180px'
    }
  })
)

export interface DatePickerRangeProps {
  defaultInitialValue?: moment.Moment | null,
  defaultFinalValue?: moment.Moment | null,
  format?: string,
  onChange: (initialDate: moment.Moment, finalDate: moment.Moment) => void;
}

export default function DatePickerRange ({ defaultInitialValue, defaultFinalValue, format, onChange }: DatePickerRangeProps): JSX.Element {
  const classes = useStyles()
  const [selectedInitialDate, setSelectedInitialDate] = React.useState<moment.Moment | null>(
    defaultInitialValue || moment().clone().startOf('month')
  )
  const [selectedFinalDate, setSelectedFinalDate] = React.useState<moment.Moment | null>(
    defaultFinalValue || moment()
  )

  const handleInitialDateChange = (date: moment.Moment | null) => {
    setSelectedInitialDate(date)
    onChange(date!, selectedFinalDate!)
    window.sessionStorage.setItem('initial_date_picker', moment(date!).clone().format('YYYY-MM-DD'))

    if (!window.sessionStorage.getItem('final_date_picker')) {
      window.sessionStorage.setItem('final_date_picker', moment().clone().format('YYYY-MM-DD'))
    }
  }

  const handleFinalDateChange = (date: moment.Moment | null) => {
    setSelectedFinalDate(date)
    onChange(selectedInitialDate!, date!)
    window.sessionStorage.setItem('final_date_picker', moment(date!).clone().format('YYYY-MM-DD'))

    if (!window.sessionStorage.getItem('initial_date_picker')) {
      window.sessionStorage.setItem('initial_date_picker', moment().clone().subtract(15, 'days').format('YYYY-MM-DD'))
    }
  }

  useEffect(() => {
    if (defaultInitialValue) setSelectedInitialDate(defaultInitialValue)
  }, [defaultInitialValue])

  useEffect(() => {
    if (defaultFinalValue) setSelectedFinalDate(defaultFinalValue)
  }, [defaultFinalValue])

  return (
    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
      <Grid container justifyContent="space-between">
        <Grid item>
          <KeyboardDatePicker
            className={classes.input}
            disableToolbar
            variant="inline"
            format={format || 'DD/MM/yyyy'}
            margin="normal"
            id="date-picker-initial"
            label="Data inicial"
            value={selectedInitialDate}
            maxDate={selectedFinalDate?.clone()}
            onChange={handleInitialDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date'
            }}
          />
        </Grid>
        <Grid item>
          <KeyboardDatePicker
            className={classes.input}
            disableToolbar
            variant="inline"
            format={format || 'DD/MM/yyyy'}
            margin="normal"
            id="date-picker-final"
            label="Data final"
            value={selectedFinalDate}
            onChange={handleFinalDateChange}
            minDate={selectedInitialDate?.clone()}
            maxDate={new Date()}
            KeyboardButtonProps={{
              'aria-label': 'change date'
            }}
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  )
}
